/*
 * Lemonade Training Oy copy rights all right reserved.
 * Config Document Type Definitions (F023)
 *
 * The `config` collection's document ids and the shape of the client-read
 * config document. The server-behaviour flags document is declared in
 * featureFlags.ts — it is deliberately NOT under the public-read
 * `match /config/{doc}` rule, so it is named here but shaped there.
 */

/** Firestore document ids under the `config` collection. */
export const CONFIG_DOC = {
  /** Public read. minAppVersion + client-side flags; read by every mobile cold start. */
  LEMONADE_CONFIG: "lemonade-config",
  /** Owner-written, non-public. Server-behaviour flags; see FeatureFlagsDoc. */
  FEATURE_FLAGS: "features",
} as const;

/** `config/lemonade-config`. Existed for years, never declared until now. */
export type LemonadeConfigDoc = {
  /** Builds below this get the Update screen on cold start. semver "M.m.p". */
  minAppVersion: string;
  /** F015 image-variant serving flag, read once at mobile startup. */
  serveImageVariants?: boolean;
};
